export class ExceptionDetail {
  message: string;
  stackTrace: string;
  innerException: ExceptionDetail;

  constructor() {
    this.innerException = new ExceptionDetail();
  }
}
